import { Box, styled } from "@mui/material";

export const DetailBoxWrapper = styled(Box)({
  fontWeight: 500,
  // textOverflow: "ellipsis",
  // whiteSpace: "nowrap",
  wordBreak: "break-word",
});
